import { START_GET_TERMS, START_ACCEPT_TERMS } from '../types';

export const getTerms = () => ({
    type: START_GET_TERMS
})

export const acceptTerms = payload => ({
    type: START_ACCEPT_TERMS,
    payload
})